import { render, staticRenderFns } from "./ServiceWebRow.vue?vue&type=template&id=1566366c&scoped=true&"
import script from "./ServiceWebRow.vue?vue&type=script&lang=js&"
export * from "./ServiceWebRow.vue?vue&type=script&lang=js&"
import style0 from "./ServiceWebRow.vue?vue&type=style&index=0&id=1566366c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1566366c",
  null
  
)

export default component.exports